import React, { useRef, useState, useEffect } from "react";
import { motion } from 'framer-motion';
import './home.css'

const initialBlogs = [
    {
  title: "Challenges in Gaming as a Full-Time Career",
  image: "https://esmaaash.in/esmaaash_web/frontend/public/images/gameblog.jpg",
  content: [
    {
      type: "text",
      value: "Time flies when you’re gaming. What starts as a quick evening session often stretches into the early hours. And now, you’re not just playing—you’re winning. Naturally, the thought strikes: Can I make this my career?"
    },
    {
      type: "text",
      value: "If that question’s been on your mind, you’re not alone. Here’s the truth: there’s never been a better time to be a gamer. But in India, choosing gaming as a full-time career still comes with its fair share of hurdles."
    },  
    {
      type: "text",
      value: "1. Stuck in the Past\nIndia has evolved rapidly—urban skylines, global achievements, economic growth. But our outlook on careers? Still stuck in the '80s."
    },
    {
      type: "text",
      value: "The “holy trinity” of career paths—Engineer, Doctor, Lawyer—remains the gold standard. While fields like fashion, photography, and writing are slowly gaining acceptance, gaming still feels like a taboo."
    },
    {
      type: "text",
      value: "Parents aren’t the villains here—they just want safety and certainty. But esports is real. And gamers like CarryMinati, MortaL, and Jonathan have shown that it’s not just viable—it can make you a national icon."
    },
    {
      type: "text",
      value: "2. Misconceptions Around Esports\nThe biggest challenge? Perception."
    },
    {
      type: "text",
      value: "To many, esports is still “just playing video games.” Unlike cricket or football, esports hasn’t yet earned its rightful place in mainstream culture."
    },
    {
      type: "text",
      value: "You’ll hear it often: “It’s just a game.”"
    },
    {
      type: "text",
      value: "But professional esports isn’t your regular gaming session. To reach the level of players like ScoutOP, it takes:\n- Rigorous training\n- Tactical analysis\n- Hours of mental and physical preparation"
    },
    {
      type: "text",
      value: "Think about it—many of us played cricket growing up. But that doesn’t make us Virat Kohli. He trained. He sacrificed. He turned a hobby into a profession. Esports is no different."
    },
    {
      type: "text",
      value: "3. Lack of Awareness\nMany still don’t understand the size and scope of the industry."
    },
    {
      type: "text",
      value: "Gaming is not just about playing—it’s a full-fledged ecosystem. From streamers and game designers to casters, analysts, and event organizers, the career options are vast."
    },
    {
      type: "text",
      value: "In countries like South Korea or the U.S., esports is already a multi-billion-dollar industry with legit job roles. India is catching up—but slowly."
    },
    {
      type: "text",
      value: "Take CarryMinati—he’s not just a gamer. He’s a content machine, India’s first YouTuber to cross 30 million subscribers, and now collaborates with global icons like MrBeast."
    },
    {
      type: "text",
      value: "4. Gaming Isn’t the Only Role\nMany believe that to work in gaming, you have to be a top-tier player.\nNot true."
    },
    {
      type: "text",
      value: "The gaming industry includes:\n🎮 Game Designers\n💻 Developers\n🎙️ Shoutcasters\n🎥 Content Creators\n👥 Team Managers\n🎟️ Tournament Organizers"
    },
    {
      type: "text",
      value: "There’s a place for everyone—whether you’re technical, creative, or managerial. Find your niche, and carve your own path."
    },
    {
      type: "text",
      value: "5. The Future is Bright—But the Road is Long\nIndia is finally waking up to esports:\n- Prize pools are rising\n- Tournaments are expanding\n- Government interest is increasing"
    },
    {
      type: "text",
      value: "Recently, even Prime Minister Narendra Modi engaged with top Indian gamers like Payal Dhare, MortaL, and Mythpat—a major milestone in legitimizing the industry."
    },
    {
      type: "text",
      value: "And gaming giants like Smaaash are getting in on the action. With the launch of Esmaaash, they’re creating dedicated platforms for esports—hosting LAN events in BGMI, Free Fire, and FC-25 to spotlight new talent."
    },
    {
      type: "text",
      value: "Final Thoughts\nLike any career, gaming isn’t easy. The hours are long. The grind is intense. And the recognition? Still growing."
    },
    {
      type: "text",
      value: "But if you’re passionate, resilient, and ready to hustle—then yes, gaming can be a full-time career in India."
    },
    {
      type: "text",
      value: "And the best part?\nWe’re just getting started."
    }
  ]
},

  {
    title: "Bowling Without the Wait: How Smaaash’s New Booking System is a Game-Changer",
    image: "https://esmaaash.in/esmaaash_web/frontend/public/images/bowling1.jpg",
    content: [
              { type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/bowling1.jpg" },
      { type: "text", value: "We live in a world of over-stimulation, where everything quickly becomes mundane. Going to clubs or house parties loses its charm after a couple of times. One thing that never gets boring is bowling. Every time you play, you get a different experience. Sometimes you come home as the winner and other times that one pin seems glued. But one thing is guaranteed win or lose, that it is always fun. I love bowling so I can be a little biased. Don’t you guys think it is a perfect activity?" },
      { type: "text", value:"<strong>Here are a few reasons why I love bowling</strong>"},
      { type: "text", value: "A simple game" },
      { type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/Kidsbowling1.jpg" },
      { type: "text", value: "I love the simplicity of bowling. You can explain it to a newcomer in just a line ‘Roll the ball down the lane to knock down the pins’." },
      { type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/shoerack.jpg" },
   { type: "text", value: "Low barrier to entry" },
   { type: "text", value: "Unlike other leisure sports like golf, squash or table tennis which require you to have your equipment and wear sport-specific attire. For bowling, all you need is a pair of bowling shoes. Most bowling alleys give you shoes for bowling, so you can just walk in and start having fun." },
   // { type: "image", value: "https://esmaaash.in/esmaaash_web/uploads/blogs/fifa.png" },
   { type: "text", value: "Bowling = Therapy" },
   { type: "text", value: "When you are in a bowling alley you forget all your worries of the day. You focus on just getting knocking the pins and having a good time. It is also a good mental and physical workout." },
   { type: "text", value: "<strong>That one Thursday</strong>" },
   { type: "text", value: "I could go on and on about why I love bowling but that’s not what this blog is about. Everything in this world has a few drawbacks, and bowling has some. You can get smelly shoes or worse, you have to wait for a bowling lane to get free for the fun times to start. I can handle smelly shoes, but waiting for a bowling lane? That’s my ultimate pet peeve. Doesn’t waiting for a lane feel like those never-ending ads before a movie? You’re just sitting there, holding off on your popcorn and drink because you want to dive in the moment the movie starts." },
      { type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/smaaash-1.jpg" },
   { type: "text", value: "I often wondered why they can’t have a booking system so people can pre- book lanes. Having a curious mind, I did talk to a few people who run bowling alleys asking why. They all have similar answers it can’t be done because no time limits, depending on the group size a game time gets extended, and few other variables they mentioned that I can’t recall. But the bottom line was it was not possible. One Thursday, out of the blue, one of my favourite bowling arenas near me sent me a message to try their new booking engine for reserving lanes on my next visit. At first, I couldn’t believe the text, I had to read it again and again. Lucky for me and my friends we were planning to hit bowling lanes that weekend. We were just stuck debating for a time when we would get the least amount of waiting time. I quickly went to the link and made my first booking for Saturday evening, which is one of the busiest times. Then I texted my group that we were going this Saturday evening. Everyone had a similar reaction, &#39;No way… are you serious?&#39; I reassured them, saying I&#39;d get us the lanes as soon as we arrived and they should trust me, but they replied with, &#39;Not in a million years.&#39;" },
   { type: "text", value: "With no other options, I finally spilled the beans about Smaaash’s booking engine. We went to Smaaash in Lower Parel that Saturday to check the credibility of their booking engine, and our lane was assigned to us within 5 minutes of walking in. I wouldn’t be wrong if I said we felt a bit like celebrities cutting lines, breaking rules and not waiting in line. We had one of the best smashing bowling nights we&#39;ve had in a long time." },
   { type: "text", value: "<strong>Smaaash’s booking engine</strong>" },
   
   { type: "text", value: "The next day, I was just curious how Smaaash was able to do the impossible. So I called their customer number to enquire a bit more about their booking engine. But that day being a Sunday they couldn’t get me connected to the minds behind this booking engine. They assured me someone from their head office would give me a call on Monday to let me know more about the booking engine." },
      { type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/booking1.jpg" },
   { type: "text", value: "After getting the call and getting into the nitty-gritty details of their booking engine, I was impressed. Their booking engine is India’s first booking engine of this kind." },
   { type: "text", value: "This way they were able to achieve this impossible task: <br> ● Data Collection: Smaaash has been in this industry for more than 12 years. This helped them to collect data on player behaviours, and the time it takes for different sizes of groups to complete a round. This helped them create the most optimised algorithm for their book engine. <br>● Dedicated Bowling Lanes for Booking Engine: They also took it a step further by creating dedicated bowling lanes for their booking engine. So it doesn’t interfere with the walk-in crowd. <br>● Easy to use UI: They create a very simple user interface for their booking engine. So people can quickly book their lanes. <br>● Exclusive web-only offers: To incentivise people to use their booking engine they also introduced exclusive web offers. <br>● A diverse booking engine: Their booking engine also lets you book their cricket simulation game which also had the same waiting issue as bowling. Plus, you can also enjoy their web-only offers on the engine." },
   { type: "text", value: "<strong>How to use the Smaaash’s Booking Engine</strong>" },
   { type: "text", value: "● Visit: Smaaash Booking Engine <br>   ● Choose your closest centre.<br> ● Pick your desired date.<br> ● Specify the number of adults and kids.<br> ● Select the number of games.<br> ● Choose your preferred time slot.<br> ● Add to cart.<br> ● Complete your payment.<br> ● Enjoy your time at Smaaash on your booking day!" },
   { type: "text", value: "Whenever you decide to go bowling you can be sure that it is going to be a fun time of getting knocking pins, yummy food and drinks. One of the most annoying things about bowling is the waiting time for lanes. But with the Smaaash booking engine, you can book lanes beforehand and skip the line. We wait for a lot of things in our lives, waiting for a lane shouldn’t be one of them. Try this booking engine to see a new way of bowling today." },
   { type: "text", value: "<strong>Meta Description</strong>" },
   { type: "text", value: "Smaaash’s booking engine has elevated India’s bowling scene. If you love bowling as much as I do, you owe it to yourself and your friends to try it out. Now go get that turkey." },    
    ]
  },

  { 
    title: "Ditch the Boring Office Party — Level Up with Smaaash!", 
      image: "https://esmaaash.in/esmaaash_web/frontend/public/images/party.jpg",
    content: [
            {type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/party.jpg"},
      { type: "text", value: "Let’s be real—most corporate parties are a snooze fest. The same old drinks, awkward small talk, and a half-hearted attempt at dancing before sneaking out early. Sound familiar? Well, it’s time to shake things up, and we know just the place! Enter Smaaash—India’s ultimate corporate playground where work meets play in the most epic way possible." },
      { type: "text", value:"<strong>The Problem with Typical Corporate Gatherings</strong>"},
      { type: "text", value: "Sure, you might know your colleague is a spreadsheet wizard, but do you know if they can drift around corners like a pro in a go-kart? Probably not. Traditional corporate parties don’t exactly foster deep connections. People clump together in familiar groups, and the night ends without much bonding (or excitement, for that matter). <br> <br> Now imagine this: instead of another predictable gathering, you and your colleagues are battling it out in a cricket match, scoring strikes in bowling, or reliving your childhood on bumper cars. Sounds way more fun, right?" },
      { type: "text", value:"<strong>Welcome to Smaaash—Where Work Meets Play</strong>"},
      { type: "text", value: "Smaaash isn’t just another event venue—it’s an experience. It’s where colleagues turn into teammates, managers become fierce competitors, and everyone gets a chance to let loose. From high-speed go-karting races to intense cricket showdowns, there’s something for everyone. Plus, with customizable event packages, your company can craft the ultimate fun- filled day." },
            {type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/bowling2.jpg",},
   { type: "text", value: "What’s on the menu?" },
   { type: "text", value: "● Bowling battles on a 10-lane setup <br>   ● Trampoline parks to unleash your inner acrobat<br> ● Bumper cars (because nothing says “team bonding” like gently ramming into your boss) <br> ● Unlimited arcade games for that nostalgic rush <br> ● Donut slides (yes, you read that right!)<br>" },
   { type: "text", value: "The best part? Dedicated event managers ensure everything runs smoothly, so all you have to do is show up and have a blast!" },
   { type: "text", value:"<strong>More Than Just a Party—It’s a Productivity Boost</strong>"},
   { type: "text", value: "You might be wondering—does all this fun actually help in the workplace? Absolutely! A happy and engaged workforce is a productive one. When employees get the chance to unwind, de- stress, and bond outside the cubicle, they return to work re-energized, more connected, and ready to tackle challenges together." },
            {type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/gokarting.jpg"},
   { type: "text", value:"<strong>Beyond Corporate Events</strong>"},
   { type: "text", value: "Think Smaaash is only for company gatherings? Think again. They also host networking events, brand launches, success celebrations, and interactive workshops. Whether you’re planning a small team outing or an extravagant company-wide bash, Smaaash has the perfect setup for you." },
            {type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/cricket.jpg"},
   { type: "text", value:"<strong>The Vision Behind the Fun</strong>"},
   { type: "text", value: "Shirish Kotmire, CEO of Smaaash Entertainment Pvt. Ltd., puts it best: “In today’s fast-paced corporate world, stress is inevitable. That’s why providing employees with opportunities to unwind and connect outside the office is crucial. At Smaaash, we don’t just offer entertainment; we create spaces for teams to bond, have fun, and build stronger relationships.”" },
   { type: "text", value:"<strong>The Ultimate Corporate Playground Awaits</strong>"},
   { type: "text", value: "Why settle for the usual, when you can take your corporate event to the next level? Smaaash isn’t just hosting parties—they’re redefining corporate engagement in India. With centers across major cities like Mumbai, Delhi, Gurugram, Noida, Hyderabad, and beyond, your next epic team outing is just a booking away." },

  ]
  },
  { 
    title: "Reviving Indian Malls: How Smaaash is Pioneering the Experience Economy", 
      image: "https://esmaaash.in/esmaaash_web/frontend/public/images/smaaashgames.jpg",
    content: [
            {type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/smaaashgames.jpg"},
      { type: "text", value:"<strong>How Smaaash is Bringing Malls Back to Life</strong>"},
      { type: "text", value: "In a rapidly evolving world, trends shift at breakneck speed. A decade ago, malls were the ultimate destination for families looking to shop, dine, and unwind. However, with the rise of online shopping and digital entertainment, foot traffic in malls has plummeted. India, home to approximately 260 malls, now sees only 70 of them thriving, with a shocking 59% increase in ghost malls in 2024 alone. The question is: what are these successful malls doing differently?" },

      { type: "text", value:"<strong>The Role of Indoor Amusement Centres (IACs) in Reviving Malls</strong>"},
      { type: "text", value: "Malls that continue to thrive have embraced the shift in consumer behavior. Having brand stores and cinema halls is no longer enough—successful malls are evolving into community hubs. One of the biggest catalysts in this transformation is the rise of Indoor Amusement Centres (IACs). Post-pandemic, the entertainment and leisure sectors have emerged as some of the fastest- growing industries in India. According to a JLL report, IACs are expected to expand to 11 million square feet by 2028, up from the current 5.5 million square feet." },

      { type: "text", value:"<strong>Smaaash: Leading the Experience Economy</strong>"},
      { type: "text", value: "At the forefront of this movement is Smaaash Entertainment, a pioneer in the gaming and entertainment space that has been redefining mall experiences for over two decades. By creating competitive social environments that merge cutting-edge gaming with high-end dining, Smaaash ensures that customers keep coming back for more." },

      { type: "text", value:"<strong>Unmatched Gaming and Entertainment Offerings</strong>"},
      { type: "text", value: "Smaaash stands out with its diverse entertainment lineup:" },
      { type: "text", value: "● 10-pin bowling<br>   ● Arcade and VR gaming<br> ● India’s first-ever 360-degree cricket simulator, featuring the bowling styles of legends like Brett Lee, Shoaib Akhtar, and Muttiah Muralitharan. <br> <br>" },
      { type: "text", value: "For millions of Indian cricket fans, Smaaash&#39;s cricket simulator offers a dream opportunity—to step onto a virtual pitch and face iconic bowlers while channeling their inner Sachin Tendulkar. This combination of high-tech entertainment and nostalgia drives significant foot traffic to malls." },


      { type: "text", value:"<strong>Innovating with Technology for a Seamless Experience</strong>"},
      { type: "text", value: "Smaaash is constantly innovating to enhance customer experience. Recognizing that long wait times for bowling lanes can impact the fun, they introduced India’s first Bowling and Cricket lanes Booking Engine. This system allows customers to skip the queue and dive straight into action—a trend that has since been adopted by other IACs, further cementing Smaaash’s reputation as an industry leader." },

      { type: "text", value:"<strong>A Playground for All Ages</strong>"},
             {type: "image", value: "https://esmaaash.in/esmaaash_web/frontend/public/images/bike-game.jpg"},

      { type: "text", value: "Smaaash isn’t just about high-energy gaming. They also cater to a wider audience with:" },
      { type: "text", value: "● Donut slides and bumper cars for kids <br>   ● Trampoline parks and redemption games<br> ● Virtual Reality experiences for a total escape from reality <br> <br>" },
      { type: "text", value: "For kids, it’s a chance to step away from screens and engage in physical play, while adults get the opportunity to relive their childhood and de-stress, even if just for a few hours." },


      { type: "text", value:"<strong>Corporate Team-Building in a Fun New Way</strong>"},
      { type: "text", value: "Beyond regular visitors, Smaaash has also positioned itself as a go-to destination for corporate team-building activities. By blending entertainment with engagement, they provide companies with a refreshing alternative to traditional office events, fostering stronger workplace bonds in an energetic environment." },

      { type: "text", value:"<strong>The Future of Indian Malls: Experience Over Shopping</strong>"},
      { type: "text", value: "In an era where malls must reinvent themselves to stay relevant, Smaaash proves that the key to survival lies in creating unforgettable experiences. By turning shopping centers into dynamic playgrounds that cater to all age groups, they are redefining the modern mall experience.  <br></br> As more consumers seek entertainment-driven outings, malls that integrate experiential attractions like Smaaash are likely to thrive—proving that the future of malls is not just in retail, but in experience-driven engagement." },

    ]
      },
  
];

export default function Blogs() {
  const scrollRef = useRef(null);
  const blogModalRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedBlog, setSelectedBlog] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const blogWidth = scrollRef.current.clientWidth / 3;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -blogWidth : blogWidth,
        behavior: "smooth",
      });
    }
  };

  const handleBackdropClick = (e) => {
    if (blogModalRef.current && !blogModalRef.current.contains(e.target)) {
      setSelectedBlog(null);
    }
  };

  return (
    <div style={{
      padding: "16px",
      maxWidth: "100%",
      overflow: "hidden",
      background: "linear-gradient(20deg, var(--colors-gray-7), var(--colors-gray-6))",
      height: "80vh",
      color: "black"
    }}>
    <motion.h2
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  data-text="RECOMMENDED BLOGS"
  className=" text-3xl font-bold mt-16 mb-4"
>
  RECOMMENDED BLOGS
</motion.h2>

      <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
        {!isMobile && (
         <button
  onClick={() => scroll("left")}
  style={{
    position: "absolute",
    left: "0",
    top: "50%",
    transform: "translateY(-50%)",
    width: "40px",
    height: "40px",
    border: "none",
    background: "#fff",
    borderRadius: "50%",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
  }}
>
  <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="black">
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
  </svg>
</button>

        )}
        <div
  ref={scrollRef}
  style={{
    display: "flex",
    overflowX: "auto",
    scrollBehavior: "smooth",
    padding: "8px",
    scrollbarWidth: "none",
    scrollSnapType: "x mandatory"
  }}
>

          {initialBlogs.map((blog, index) => (
<div
  key={index}
  style={{
    flex: "0 0 auto",
    width: "100%",
    maxWidth: "350px",      // 👈 Card won't stretch wider than this
    background: "rgb(161 84 141)",
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    scrollSnapAlign: "center",
    borderRadius: "8px",
    color: "#fff",
    marginRight: "12px",     // 👈 space between cards
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  }}
>
  {blog.image && (
    <img
      src={blog.image}
      alt={blog.title}
      style={{
        width: "100%",
        height: "180px",
        objectFit: "cover",
        borderRadius: "4px",
        marginBottom: "8px"
      }}
    />
  )}
  <h3 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "8px" }}>{blog.title}</h3>
  <p style={{ fontSize: "14px" }}>Click below to read more</p>
  <button
    onClick={() => setSelectedBlog(blog)}
    style={{
      marginTop: "auto",
      color: "#fff",
      backgroundColor: "#333",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      borderRadius: "4px"
    }}
  >
    Read More
  </button>
</div>


          ))}
        </div>
        {!isMobile && (
<button
  onClick={() => scroll("right")}
  style={{
    position: "absolute",
    right: "0",
    top: "50%",
    transform: "translateY(-50%)",
    width: "40px",
    height: "40px",
    border: "none",
    background: "#fff",
    borderRadius: "50%",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
  }}
>
  <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="black" style={{ transform: "rotate(180deg)" }}>
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
  </svg>
</button>

        )}
      </div>

      {selectedBlog && (
        <div onClick={handleBackdropClick} style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
         <div ref={blogModalRef} style={{
  background: "#fff",
  padding: "20px",
  maxWidth: "500px",
  width: "90%",
  maxHeight: "80vh",
  borderRadius: "8px",
  overflowY: "auto",
  textAlign: "left",
  position: "relative"
}}>
  {/* Close (X) button in top-right */}
  <button onClick={() => setSelectedBlog(null)} style={{
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "transparent",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#333"
  }}>×</button>

            <h2 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}>{selectedBlog.title}</h2>
            {selectedBlog.content && selectedBlog.content.map((item, idx) => (
              <div key={idx} style={{ marginBottom: "10px" }}>
                {item.type === "text" ? (
                  <p style={{ fontSize: "14px", color: "#555" }} dangerouslySetInnerHTML={{ __html: item.value }} />
                ) : (
                  <img src={item.value} alt="Blog visual" style={{ width: "100%", borderRadius: "8px" }} />
                )}
              </div>
            ))}
            <button onClick={() => setSelectedBlog(null)} style={{
              background: "#007BFF",
              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginTop: "10px"
            }}>Read Less</button>
          </div>
        </div>
      )}
    </div>
  );
}